// Tooltips demo data
const TOOLTIP_DEMO_DATA = [
  {
    type: 'button',
    label: 'Hover or focus me',
    tooltip: (
      <>
        From Top
        <br />
        tooltip-top
      </>
    ),
  },
  {
    type: 'link',
    label: 'Link with tooltip',
    tooltip: (
      <>
        From Top
        <br />
        tooltip-top
      </>
    ),
    href: '#',
  },
  {
    type: 'chip',
    label: 'Hover/focus chip',
    tooltip: (
      <>
        From Top
        <br />
        tooltip-top
      </>
    ),
  },
  {
    type: 'button',
    label: 'Bottom Start',
    tooltip: (
      <>
        From Bottom Start
        <br />
        tooltip-bottom-start
      </>
    ),
    placement: 'bottom-start',
  },
  {
    type: 'button',
    label: 'Bottom End',
    tooltip: (
      <>
        From Bottom End
        <br />
        tooltip-bottom-end
      </>
    ),
    placement: 'bottom-end',
  },
  {
    type: 'button',
    label: 'Top Start',
    tooltip: (
      <>
        From Top Start
        <br />
        tooltip-top-start
      </>
    ),
    placement: 'top-start',
  },
  {
    type: 'button',
    label: 'Top End',
    tooltip: (
      <>
        From Top End
        <br />
        tooltip-top-end
      </>
    ),
    placement: 'top-end',
  },
  {
    type: 'button',
    label: 'Left',
    tooltip: (
      <>
        From Left
        <br />
        tooltip-left
      </>
    ),
    placement: 'left',
  },
  {
    type: 'button',
    label: 'Right',
    tooltip: (
      <>
        Right
        <br />
        tooltip-right
      </>
    ),
    placement: 'right',
  },
];

export { TOOLTIP_DEMO_DATA };
